<template>
    <div class="game-description-holder">
        <h2 v-if="title" v-text="title"></h2>
        <hr v-if="title" />
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: '',
        },
    },
};
</script>

<style scoped>
.game-description-holder {
    height: auto;
    min-height: 40px;
    background-color: #fff;
    margin: 10px;
    border-radius: 5px;
    color: #4a4a4a;
    padding: 20px;
}

.game-description-holder h2 {
    line-height: 40px;
    text-indent: 10px;
}

.game-description-holder hr {
    width: 1px solid #4a4a4a;
    margin-bottom: 10px;
}

.game-description-holder p {
    margin: 20px auto;
    font-size: 16px;
    letter-spacing: -0.2px;
}

.game-description-holder a {
    text-decoration: none;
    color: #014c78;
}

.game-description-holder a:hover {
    text-decoration: underline;
}
</style>
